module.exports = __webpack_public_path__ + "static/media/begin6newCredit.f6f0b9ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/begin6newCredit.png
// module id = 1539
// module chunks = 0